import { render, staticRenderFns } from "./InvoiceInfoCard.vue?vue&type=template&id=66cf7b2f&scoped=true&"
import script from "./InvoiceInfoCard.vue?vue&type=script&lang=ts&"
export * from "./InvoiceInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf7b2f",
  null
  
)

export default component.exports